import { t } from "i18next";
import React from "react";

export const Features = (props) => {
  return (
    <div id="features" className="text-center">
      <div className="container">
        <div className="col-md-10 col-md-offset-1 section-title">
          <h2>{t("values")}</h2>
        </div>
        <div className="row features-container">
          <div className="col-xs-6 col-md-3">
            <i class="fa-solid fa-scale-balanced fa"></i>
            <h3>{t("integrity")}</h3>
            <p>{t("integrity_text")}</p>
          </div>
          <div className="col-xs-6 col-md-3">
            <i class="fa-solid fa-user-check fa"></i>
            <h3>{t("customer-exp")}</h3>
            <p>{t("customer-exp_text")}</p>
          </div>
          <div className="col-xs-6 col-md-3">
            <i class="fa-solid fa-users fa"></i>
            <h3>{t("team-work")}</h3>
            <p>{t("team-work_text")}</p>
          </div>
          <div className="col-xs-6 col-md-3">
            <i class="fa-solid fa-wand-magic-sparkles fa"></i>
            <h3>{t("innovation")}</h3>
            {/* <p>{t("innovation_text")}</p> */}
            <p>
              القدرة على إيجاد أفكار وحلول محاسبيه جديدة ومميزة تضيف قيمه وتعمل
              علي تطوير الأساليب التقليدية للانظمه المحاسبيه ويعد مفتاح التقدم
              والتميز في مجال برامج الحسابات وانظمه
              <p>ERP System</p>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
